;(function () {
  'use strict'

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  const SELECTOR_DATEPICKER$1 = '#datepicker__general'
  const SELECTOR_DATEPICKER$2 = '#booking__calendars'

  const SELECTOR_DATE$1 = '#arriveDate'
  const SELECTOR_DATE$2 = '#departureDate'
  const SELECTOR_DATE$3 = '#altDates'

  let opened = 0
  let start = $(SELECTOR_DATE$1).attr('value')
  let end = $(SELECTOR_DATE$2).attr('value')

  /**
   * ------------------------------------------------------------------------
   * Functions - Public
   * ------------------------------------------------------------------------
   */

  const datepickerGeneral = () => {}

  const datepickerBooking = () => {
    $(SELECTOR_DATEPICKER$2).datepicker({
      dateFormat: 'dd-mm-yy',
      numberOfMonths: 2,
      minDate: new Date(),
      beforeShowDay: function (date) {
        setTimeout(function() {
          document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
            e.setAttribute('tabindex', '-1');
          })
        }, 1000);
        $.datepicker._defaults.dateFormat = 'dd-mm-yy'

        let startDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          start,
        )

        let endDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          end,
        )

        if (date.getTime() == startDate.getTime()) {
          return [true, 'startday']
        } else {
          if (date.getTime() == endDate.getTime()) {
            return [true, 'endday']
          } else {
            if (
              date.getTime() > startDate.getTime() &&
              date.getTime() < endDate.getTime()
            ) {
              return [true, 'days']
            } else {
              return [true, '']
            }
          }
        }
      },
      onSelect: function (date) {
        let arrive = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          start,
        )
        let departure = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          end,
        )
        let selectedDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          date,
        )

        if (opened == 0) {
          opened = 1
          start = date
          end = date
        } else {
          opened = 0
          if (selectedDate <= arrive) {
            end = start
            start = date
          } else {
            end = date
          }
        }

        $(SELECTOR_DATE$1).attr('value', start)
        $(SELECTOR_DATE$2).attr('value', end)

        let SplitArrive = start.split('-')
        let SplitDeparture = end.split('-')

        $(SELECTOR_DATE$3).attr(
          'value',
          SplitArrive[0] +
            '-' +
            SplitArrive[1] +
            '-' +
            SplitArrive[2] +
            ' / ' +
            (SplitDeparture[0] +
              '-' +
              SplitDeparture[1] +
              '-' +
              SplitDeparture[2]),
        )
      },
    })
  }

  /**
   * ------------------------------------------------------------------------
   * DOM Content Loaded is ready available
   * @param {*} callback
   * ------------------------------------------------------------------------
   */
  const onDOMLoaded = (callback) => {
    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(callback, 1)
      })
    } else {
      document.addEventListener('DOMContentLoaded', callback)
    }
  }

  onDOMLoaded(datepickerBooking())
})()
